import {
  SET_UNSAVED_FLAG,
  SET_APP_STATE_INITIAL,
  SET_COMPANY_DATA,
  SET_PROJECT_DETAIL,
  SET_APP_IS_LOADING,
  SET_APP_ERROR,
  SET_DATA_SETTINGS,
  SET_VIEW_ALL_SECTIONS_ENABLED,
  SET_COMPANY_DATA_VALID,
  SET_REPORT_IS_LOADING
} from "./mutations";

const initialState = {
  unsaved: false,
  companyData: {
    companyInfo: {},
    id: "",
    companyName: "",
    createdAt: "",
    updatedAt: "",
    status: ""
  },
  projectDetail: {},
  dataSettings: {
    endDate: null,
    yearsToFetch: 5,
  },
  isLoading: false,
  isError: false,
  error: null,
  viewAllSectionsEnabled: false,
  companyDataValid: "false",
  reportLoading: "false",
};

const appStateReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_APP_IS_LOADING:
      return {
        ...state,
        isLoading: payload,
      };

    case SET_APP_ERROR:
      return {
        ...state,
        isError: payload.state,
        error: payload.message,
      };

    case SET_UNSAVED_FLAG:
      return {
        ...state,
        unsaved: payload,
      };

    case SET_COMPANY_DATA:
      return {
        ...state,
        companyData: payload,
      };

    case SET_PROJECT_DETAIL:
      return {
        ...state,
        projectDetail: payload,
      };

    case SET_DATA_SETTINGS:
      return {
        ...state,
        dataSettings: { ...state.dataSettings, ...payload },
      };

    case SET_APP_STATE_INITIAL:
      return {
        ...initialState,
      };

    case SET_VIEW_ALL_SECTIONS_ENABLED:
      return { ...state, viewAllSectionsEnabled: payload }

    case SET_COMPANY_DATA_VALID:
      return { ...state, companyDataValid: payload }

    case SET_REPORT_IS_LOADING:
      return { ...state, reportLoading: payload }

    default:
      return state;
  }
};

export default appStateReducer;
